import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../utils/propUtils';
import VeltCommentsSidebarStatusDropdownContentWireframe from './VeltCommentsSidebarStatusDropdownContentWireframe/VeltCommentsSidebarStatusDropdownContentWireframe';
import VeltCommentsSidebarStatusDropdownTriggerWireframe from './VeltCommentsSidebarStatusDropdownTriggerWireframe/VeltCommentsSidebarStatusDropdownTriggerWireframe';
;
var VeltCommentsSidebarStatusDropdownWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-status-dropdown-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarStatusDropdownWireframe.Trigger = VeltCommentsSidebarStatusDropdownTriggerWireframe;
VeltCommentsSidebarStatusDropdownWireframe.Content = VeltCommentsSidebarStatusDropdownContentWireframe;
export default VeltCommentsSidebarStatusDropdownWireframe;
